import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { SimulationInfo } from '@classes/simulation/simulation-info';
import { SimulationService } from '@services/simulation.service';
import { InvestService } from '@services/invest.service';
import { SimulationVisibilityType } from '@enums/simulation-visibility-type.enum';

@Component({
    selector: 'app-simulation-select',
    templateUrl: './simulation-select.component.html',
    styleUrls: ['./simulation-select.component.scss']
})
export class SimulationSelectComponent implements OnInit {
    @Input() selectedSimu: string;

    simulations: SimulationInfo[];
    selectForm: FormGroup;
    isLoading: boolean;

    constructor(
        private simuSrv: SimulationService,
        private investSrv: InvestService,
        private fb: FormBuilder
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    getInvest(): void {
        this.investSrv.get(this.selectForm.value.simulation).subscribe();
    }

    private initSubscriptions(): void {
        this.simuSrv.getInfoList()
        .subscribe(simulationsList => {
            this.simulations = simulationsList.filter(s => s.visibility === SimulationVisibilityType.perso);
            this.initForm();
        });
    }

    private initForm(): void {
        this.selectForm = this.fb.group({
            simulation: [this.selectedSimu, Validators.required]
        });
    }
}
